import React from 'react';
import { Row, Col } from 'antd';

const SpaceDetailsLoader = () => (
    <div className="my-space-details host-dashboard">     
      <div className="space-details-container">
          
          {/* Header Section */}
          <div className="header-section">
             <div className="title-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div className="names-container" style={{ width: '60%' }}>
                    <div className="loading-shimmer" style={{ width: '80%', height: '32px', marginBottom: '8px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="loading-shimmer" style={{ width: '120px', height: '20px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                </div>
                <div className="loading-shimmer" style={{ width: '100px', height: '32px', borderRadius: '16px', backgroundColor: '#f0f0f0' }} />
             </div>
             
             <div className="address" style={{ marginTop: '16px' }}>
                <div className="loading-shimmer" style={{ width: '40%', height: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
             </div>
          </div>
          
          {/* Photo Gallery */}
          <div className="photo-gallery" style={{ marginTop: '24px' }}>
              <div className="gallery-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gridTemplateRows: 'repeat(2, 200px)', gap: '8px' }}>
                 <div className="gallery-item loading-shimmer" style={{ gridColumn: '1 / 3', gridRow: '1 / 3', backgroundColor: '#f0f0f0', borderRadius: '8px', height: '100%' }} />
                 <div className="gallery-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '100%' }} />
                 <div className="gallery-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '100%' }} />
                 <div className="gallery-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '100%' }} />
                 <div className="gallery-item loading-shimmer" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '100%' }} />
              </div>
          </div>

          <Row gutter={48} style={{ marginTop: '32px' }}>
            <Col xs={24} md={24}>
                {/* Key Details */}
                <div className="details-section">
                    <div className="key-details" style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
                        {[...Array(6)].map((_, i) => (
                           <div key={i} className="detail-item" style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: '200px' }}>
                              <div className="loading-shimmer" style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0' }} />
                              <div className="detail-text">
                                  <div className="loading-shimmer" style={{ width: '100px', height: '12px', marginBottom: '6px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                                  <div className="loading-shimmer" style={{ width: '60px', height: '12px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                              </div>
                           </div>
                        ))}
                    </div>
                </div>

                {/* Amenities */}
                <div className="details-section" style={{ marginTop: '32px' }}>
                    <div className="loading-shimmer" style={{ width: '200px', height: '24px', marginBottom: '24px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="amenities-list" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className="amenity-item" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div className="loading-shimmer" style={{ width: '24px', height: '24px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                                <div className="loading-shimmer" style={{ width: '120px', height: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Description */}
                <div className="details-section" style={{ marginTop: '32px' }}>
                    <div className="loading-shimmer" style={{ width: '180px', height: '24px', marginBottom: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="loading-shimmer" style={{ width: '100%', height: '14px', marginBottom: '10px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="loading-shimmer" style={{ width: '100%', height: '14px', marginBottom: '10px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="loading-shimmer" style={{ width: '90%', height: '14px', marginBottom: '10px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                    <div className="loading-shimmer" style={{ width: '60%', height: '14px', marginBottom: '10px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                </div>
                
                {/* Rules */}
                <div className="details-section" style={{ marginTop: '32px' }}>
                     <div className="loading-shimmer" style={{ width: '150px', height: '24px', marginBottom: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                     <div className="rules-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                         {[...Array(3)].map((_, i) => (
                             <div key={i} className="rule-item" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                 <div className="loading-shimmer" style={{ width: '20px', height: '20px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                                 <div className="loading-shimmer" style={{ width: '300px', height: '16px', borderRadius: '4px', backgroundColor: '#f0f0f0' }} />
                             </div>
                         ))}
                     </div>
                </div>
            </Col>
          </Row>

        </div>
      {/* </div> removed */}
    
      <style>{`
        @keyframes shimmer {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
        .loading-shimmer {
          animation: shimmer 1.5s infinite ease-in-out;
        }
        @media (max-width: 768px) {
            .gallery-grid {
                grid-template-columns: 1fr !important;
                grid-template-rows: auto !important;
            }
            .gallery-item {
                height: 200px !important;
                margin-bottom: 8px;
                grid-column: auto !important;
                grid-row: auto !important;
            }
        }
      `}</style>
  </div>
);

export default SpaceDetailsLoader;